import { useCallback, useState } from 'react';

export const useCommentInput = ({
  onNewCommentPostHandler,
  onCommentSaveHandler,
  onBeforeCreate
}) => {
  const [commentInputContext, setCommentInputContext] = useState(null);
  const [commentInputValue, setCommentInputValue] = useState('');
  const [focusInputTrigger, setFocusInputTrigger] = useState(0);

  const onCancelContextHandler = useCallback(() => {
    setCommentInputContext(null);
    setCommentInputValue('');
  }, []);

  const openCommentInputHandler = useCallback((editData) => {
    setCommentInputContext(editData);
    setCommentInputValue((!editData?.replying && editData?.value) || '');
    setFocusInputTrigger((prev) => prev + 1);
  }, []);

  const onCommentSubmitHandler = useCallback(
    async (value) => {
      if (!commentInputContext?.replying && commentInputContext?.commentId) {
        await onCommentSaveHandler(
          { id: commentInputContext.commentId, value },
          {
            isReply: commentInputContext.isReply,
            parentCommentId: commentInputContext.parentCommentId
          }
        );
        onCancelContextHandler();
        return;
      }

      onBeforeCreate?.();

      await onNewCommentPostHandler(value, { parentCommentId: commentInputContext?.commentId });
      onCancelContextHandler();
    },
    [
      commentInputContext,
      onCancelContextHandler,
      onCommentSaveHandler,
      onNewCommentPostHandler,
      onBeforeCreate
    ]
  );

  return {
    commentInputContext,
    commentInputValue,
    focusInputTrigger,
    setCommentInputValue,
    onCancelContextHandler,
    openCommentInputHandler,
    onCommentSubmitHandler
  };
};
